module.exports = __webpack_public_path__ + "videos/colordrop-jp.1ac5d90.mp4";